import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { endpoints, gisApiEndpoints } from '@app/constants';
import { catchError, mergeMap } from 'rxjs/operators';
import { HttpService } from '@app/core/services/http/http.service';
import { GisHealth, Health } from './health.models';
import { environment } from '@env/index';

@Injectable({
  providedIn: 'root'
})
export class HealthService {

  constructor(
    private http: HttpService
  ) { }


  getHealth = (): Observable<object> => {
    return this.http
      .get({
        url: `${endpoints.health}`
      })
      .pipe(
        mergeMap(this.handleHealthResponse),
        catchError((error) => throwError(error))
      );
  }

  getGisApiHealth = (): Observable<GisHealth> => {
    return this.http
      .get({
        url: `${gisApiEndpoints.health}`,
        baseUrl: `${environment.gisApiUrl}`
      })
      .pipe(
        mergeMap(this.handleGisHealthResponse),
        catchError((error) => throwError(error))
      );
  }

  private handleHealthResponse(response: Health): Observable<Health> {
    return of(response);
  }

  private handleGisHealthResponse(response: GisHealth): Observable<GisHealth> {
    return of(response);
  }
}
